const LOCATION_FIELDS = new Set([
  'catalogcontinents_id',
  'catalogregions_id',
  'catalogcountries_id',
]);

const MULTI_FIELDS = new Set([
  'catalogciiu_levels',
  'catalogsection_levels',
  'catalogphase_levels',
  'cataloginstitution_levels',
]);

const MODULES_WITH_INDICATORS = new Set([
  'technology',
  'alternative',
  'experience',
  'innovation',
  'assistance',
  'financial',
]);

export const PANEL_INDICATORS = [
  { name: 'deep_indicator', min: 'deep_indicator_min', max: 'deep_indicator_max' },
  { name: 'protection_indicator', min: 'protection_indicator_min', max: 'protection_indicator_max' },
  { name: 'applicability_indicator', min: 'applicability_indicator_min', max: 'applicability_indicator_max' },
  { name: 'relevance_indicator', min: 'relevance_indicator_min', max: 'relevance_indicator_max' },
  { name: 'mitigation_indicator', min: 'mitigation_indicator_min', max: 'mitigation_indicator_max' },
  { name: 'adaptation_indicator', min: 'adaptation_indicator_min', max: 'adaptation_indicator_max' },
  { name: 'performance_indicator', min: 'performance_indicator_min', max: 'performance_indicator_max' },
];

export const getPanelComboDataList = (fieldName, state) => {
  const catalog = state.catalog || {};
  const map = {
    catalogserie_id: catalog.listSeriesFilter,
    catalogsophistication_id: catalog.listSophisticationsFilter,
    catalogmagnitude_id: catalog.listMagnitudesFilter,
    catalogsize_id: catalog.listSizesFilter,
    catalogtypology_id: catalog.listTypologiesFilter,
    catalogpricerange_id: catalog.listPriceRangesFilter,
    catalogcomplexity_id: catalog.listComplexitiesFilter,
    catalogmeasure_id: catalog.listMeasuresFilter,
    catalogstrategy_id: catalog.listStrategiesFilter,
    catalogamplitude_id: catalog.listAmplitudesFilter,
    catalogmitigation_id: catalog.listMitigationsFilter,
    catalogconcern_id: catalog.listConcernsFilter,
    catalogproblem_id: catalog.listProblemsFilter,
    catalogproblem_ids: catalog.listProblemsFilter,
    catalogciiu_levels: state.catalogCiiu?.listCiiusFilter,
    catalogsection_levels: state.catalogSection?.listSectionsFilter,
    catalogphase_levels: state.catalogPhase?.listPhasesFilter,
    cataloginstitution_levels: state.catalogInstitution?.listInstitutionsFilter,
    cataloginstitutions_id: state.catalogInstitution?.listInstitutionsFilter,
    catalogcontinents_id: state.locationCountry?.listContinentsFilter,
    catalogregions_id: state.locationCountry?.listRegionsFilter,
    catalogcountries_id: state.locationCountry?.listCountriesFilter,
  };
  return map[fieldName] || [];
};

export const panelComboWidgetKind = (combo) => {
  if (combo.widget === 'ciiu_level' || MULTI_FIELDS.has(combo.field_name)) return 'multi';
  if (LOCATION_FIELDS.has(combo.field_name)) return 'location';
  return 'select';
};

export const moduleHasIndicators = (moduleKey) => MODULES_WITH_INDICATORS.has(moduleKey);
